import { BaseApiModel } from './BaseApiModel';

export class Color extends BaseApiModel {
  public code: string;
  public description: string;
  public regionId: string;
  public createdAt: string;
  public modifiedAt: string;
  public deletedAt: string;
}
